<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div :class="panelMode ? 'p-3' :'container mt-4 mb-4'">
    <div class="mt-2" style="max-width:597px">
        <h3>Rediger valg i gruppen "{{addOnGroup.name}}"</h3>

        <div v-if="isFromLibrary" class="alert alert-info mt-4">
          Navn og pris styres av tilbehørsbiblioteket, og oppdateres automatisk i alle gruppene som bruker valget.
          <div class="mt-2">
            <a href="#" @click.prevent="unlinkFromLibrary">Koble fra biblioteket</a>
          </div>
        </div>

        <div class="mt-5">
          <span class="ingredient-title">Navn</span>
          <input class="form-control" type="text" v-model="addOn.name" :disabled="isFromLibrary"/>
        </div>

        <div class="ingredient-title mt-4">Pris</div>
        <div class="row mt-2">
          <div class="mt-3"><strong> Ta med/takeaway </strong></div>
          <div class="col-sm-6 d-inline-block">
            <input class="form-control" type="number" min="0" v-model="price" @input="updatePriceWithVat()" :disabled="isFromLibrary"/>
            <span class="ms-2">(uten MVA)</span>
          </div>

          <div class="col-sm-6 d-inline-block">
            <input class="form-control" type="number" min="0" v-model="priceWithVat" @input="updatePrice()" :disabled="isFromLibrary"/>
            <span class="ms-2">
              (med MVA for TAKEAWAY, {{ vat.takeOut }}%)
            </span>
          </div>
        </div>

        <div v-if="useFunctionality === 'POS' || useFunctionality === 'KIOSK_TAKEAWAY' || useFunctionality === 'ALL'" class="row mt-2">
          <div class="mt-3"><strong> Spise her </strong></div>
          <div class="col-sm-6 d-inline-block">
            <input class="form-control" type="number" min="0" v-model="priceDineIn" @input="updatePriceDineInWithVat()" :disabled="isFromLibrary"/>
            <span>
                (uten MVA)
              </span>
          </div>
          <div class="col-sm-6 d-inline-block">
            <input class="form-control" type="number" min="0" v-model="priceDineInWithVat" @input="updatePriceDineIn()" :disabled="isFromLibrary"/>
            <span>
                (med MVA for SPISE HER, {{ vat.dineIn }}%)
              </span>
          </div>
          <div v-if="dineInPriceSuggestion" class="mt-1">
            <a href="#" class="bo_suggestion-btn" @click.prevent="applyDineInPriceSuggestion">
              Klikk for å bruke samme grunnpris som ta med: kr {{ dineInPriceSuggestion }} uten mva = kr {{ dineInPriceSuggestionWithVat }} med {{ vat.dineIn }}% mva
            </a>
          </div>
        </div>

        <div v-if="addOnAllowMultipleTimes" :class="addOn.allowMultipleTimes ? 'form-control' : ''">
          <div class="form-switch-wrapper mt-2 mb-3">
            <label class="form-switch">
              <div class="form-switch-container">
                <span class="bold me-2">Tillatt å velge flere ganger</span>
                <input type="checkbox" v-model="addOn.allowMultipleTimes" />
                <i></i>
              </div>
            </label>
          </div>
          <div v-if="addOn.allowMultipleTimes" class="col-sm-8">
            <div class="col-sm-8">Maksimalt tillatt antall</div>
            <input type="number" min="2" max="100" v-model="addOn.maximum" />
          </div>
        </div>

        <div class="bo_hr mt-4">
          <hr/>
        </div>

        <div class="mb-5">
          <button v-if="activateSaveButton" type="button" class="bo_btn" @click="saveAddOn"> Lagre </button>
          <button v-else type="button" class="bo_btn" @click="saveAddOn" disabled="true"> Lagre </button>
        </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import MerchantUtil from "@/util/MerchantUtil";
import ProductService from "@/services/product/ProductService";
import ItemUtil from "@/util/ItemUtil";

export default {
  components: {LoadingSpinner},
  props: {
    panelMode: { type: Boolean, default: false },
    addOnGroupIdProp: { type: String, default: '' },
    addOnIdProp: { type: String, default: '' }
  },
  emits: ['saved'],
  data() {
    return {
      loading: false,

      addOnGroupId: "",
      addOnId: "",
      addOnGroup: {},
      vat: {},

      price: 0,               //Takeaway price without VAT
      priceWithVat: "",       //Takeaway price with VAT
      priceDineIn: 0,         //Dine-in price without VAT
      priceDineInWithVat: "", //Dine-in price with VAT

      addOn: {
        type: "add-on",
        merchant: "",
        addOnGroupId: "",
        name: "",
        price: 0,
        priceDineIn: 0,
        allowMultipleTimes: false,
        maximum: 100,
        sortOrder: -1
      }
    };
  },
  mounted() {
    this.addOnGroupId = this.addOnGroupIdProp || this.$route.query.addOnGroupId;
    this.addOnId = this.addOnIdProp || this.$route.query.addOnId;
    ProductService.getDataForAddOnAdminGui(this.addOnGroupId, this.addOnId).then(
        (response) => {
          let dataForGui = response.data;
          this.addOnGroup = dataForGui.addOnGroup;
          this.addOn = dataForGui.addOn;
          this.vat = dataForGui.vat;

          this.price = this.addOn.price;
          this.priceDineIn = this.addOn.priceDineIn;
          this.updatePricesWithVat();

          this.loading = false;
        },
        (error) => {
          console.log(error);
        }
    );
  },
  computed: {
    useFunctionality(){
      return MerchantUtil.useFunctionality();
    },
    activateSaveButton(){
      if(this.addOn.name.length > 0){
        return true;
      } else {
        return false;
      }
    },
    addOnAllowMultipleTimes(){
      return MerchantUtil.addOnAllowMultipleTimes();
    },
    isFromLibrary(){
      return !!this.addOn.templateId;
    },
    dineInPriceSuggestion(){
      //Suggest the same base price as takeaway, but only when the dine-in price has not been filled in yet
      if(this.isFromLibrary || this.price === "" || Number(this.price) <= 0){
        return null;
      }
      if(Number(this.priceDineIn) > 0){
        return null; //Already filled in
      }
      return Number(this.price);
    },
    dineInPriceSuggestionWithVat(){
      return ItemUtil.getPriceDineIn(this.dineInPriceSuggestion || 0, this.vat);
    }
  },
  methods: {
    unlinkFromLibrary(){
      //EditAddOn on the server removes empty templateId/itemId from the document on save
      this.addOn.templateId = "";
      this.addOn.itemId = "";
    },
    updatePricesWithVat(){
      let priceWithVat = this.price + (this.price / 100 * this.vat.takeOut);
      this.priceWithVat = Math.round(priceWithVat);

      let priceDineInWithVat = this.priceDineIn + (this.priceDineIn / 100 * this.vat.dineIn);
      this.priceDineInWithVat = Math.round(priceDineInWithVat);
    },
    updatePriceWithVat(){
      let priceWithVat = this.price + (this.price / 100 * this.vat.takeOut);
      this.priceWithVat = Math.round(priceWithVat);
    },
    updatePriceDineInWithVat(){
      let priceDineInWithVat = this.priceDineIn + (this.priceDineIn / 100 * this.vat.dineIn);
      this.priceDineInWithVat = Math.round(priceDineInWithVat);
    },
    updatePrice(){
      this.price = ItemUtil.getPriceWithoutVat(this.vat.takeOut, this.priceWithVat);
    },
    updatePriceDineIn(){
      this.priceDineIn = ItemUtil.getPriceWithoutVat(this.vat.dineIn, this.priceDineInWithVat);
    },
    applyDineInPriceSuggestion(){
      this.priceDineIn = Number(this.price);
      this.updatePriceDineInWithVat();
    },
    saveAddOn(){
      this.loading = true;

      this.addOn.price = this.price;
      this.addOn.priceDineIn = this.priceDineIn;
      this.editAddOn(this.addOn);
    },
    editAddOn(addOn){
      console.log('addOn: ' + JSON.stringify(addOn));
      ProductService.editAddOn(addOn).then(
          (response) => {
            let documentId = response.data;
            if(documentId){
              if(this.panelMode){ this.$emit('saved'); } else { this.$router.push({ path: 'products'}); }
            } else {
              console.log("Editing addOn failed");
            }
            this.loading = false;
          },
          (error) => {
            console.log(error);
          }
      );
    }
  }
};
</script>
